var map = {
	"./advent-calendar-overlay.component": "G+Fo",
	"./external-html-content.component": "NprR",
	"./smart-sorted.component": "2jHQ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "OTKp";


//////////////////
// WEBPACK FOOTER
// ./src/app/collage-designer/additional-info-item-components ^\.\/.*\.component$
// module id = OTKp
// module chunks = 1